import { ValueContainerProps, GroupBase } from 'react-select';
import { FilterChipOption } from './CustomOption';
import styles from './styles.module.scss';

export const ValueContainer = <
  T = string,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<FilterChipOption<T>> = GroupBase<FilterChipOption<T>>,
>({
  children,
  ...props
}: ValueContainerProps<FilterChipOption<T>, IsMulti, Group>) => {
  // The input component is the second element in children
  const input = Array.isArray(children) ? children[1] : null;
  return (
    <div {...props.innerProps} className={styles.valueContainer}>
      {input}
    </div>
  );
};
